<template>
  <div
    id="box"
    :class="[posterImageStatus ? 'noscroll product-con' : 'product-con']"
    ref="box"
  >
    <div class="goods-info">
      <div id="title0" ref="header" class="basic-info">
        <div class="goods-top" v-if="storeInfo.type == 'service'">
          <div class="goods-title">
            <div class="introduce">
              {{ storeInfo.store_name }}
              <span>自营</span>
            </div>
            <div class="info">{{ storeInfo.store_info }}</div>
          </div>
          <div class="bnt-share">
            <div class="item" @click="setCollect">
              <div
                class="iconfont"
                :class="
                  storeInfo.userCollect ? 'icon-shoucang1' : 'icon-shoucang'
                "
              ></div>
              <div>收藏</div>
            </div>
            <div class="item" @click="listenerActionSheet">
              <div class="iconfont icon-fenxiang"></div>
              <div>分享</div>
            </div>
          </div>
        </div>
        <div class="goods-top-direct">
          <product-con-swiper
            :img-urls="storeInfo.slider_image"
            :videoline="storeInfo.video_link"
            :goodsImg="storeInfo.slider_image[0]"
          ></product-con-swiper>
          <div class="wrapper">
            <div class="goods-title" v-if="storeInfo.type == 'goods'">
              <div class="introduce" v-if="storeInfo.type == 'goods'">
                {{ storeInfo.store_name }}
                <span>自营</span>
              </div>
              <div class="info" v-if="storeInfo.type == 'goods'">
                {{ storeInfo.store_info }}
              </div>
            </div>
            <div class="bnt-share" v-if="storeInfo.type == 'goods'">
              <div class="item" @click="setCollect">
                <div
                  class="iconfont"
                  :class="
                    storeInfo.userCollect ? 'icon-shoucang1' : 'icon-shoucang'
                  "
                ></div>
                <div>收藏</div>
              </div>
              <div class="item" @click="listenerActionSheet">
                <div class="iconfont icon-fenxiang"></div>
                <div>分享</div>
              </div>
            </div>
            <div class="property_con">
              <Product-window
                v-on:changeFun="changeFun"
                :attr="attr"
                :iSNum="storeInfo.is_num"
              ></Product-window>
            </div>
            <div class="property_con product-window" v-if="flase">
              <div class="productWinList">
                <div class="item">
                  <div class="title">
                    服务标准
                    <i class="unfold" @click="bussinessType = !bussinessType">
                      <Icon
                        :type="
                          bussinessType ? 'ios-arrow-up' : 'ios-arrow-down'
                        "
                      />
                    </i>
                  </div>

                  <div
                    class="serve-standard listn acea-row row-middle"
                    ref="bussinessTypeRef"
                    :class="bussinessType ? 'show' : 'hidde'"
                  >
                    <div
                      class="itemn item"
                      v-for="(itemn, indexn) in attrtext"
                      :key="indexn"
                    >
                      <Icon type="ios-checkmark" />
                      {{ itemn }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="price acea-row row-between row-bottom">
              <div class="price-top price-list">
                <i>价格</i>
                <div class="money font-color-red">
                  ￥
                  <span class="num">{{ storeInfo.price }}</span>
                  {{ storeInfo.unit_name }}
                  <!-- <img
              src="@assets/images/vip.png"
              class="image"
              v-if="storeInfo.vip_price && storeInfo.vip_price > 0"
                />-->
                  <!-- <span
              class="vip-money"
              v-if="storeInfo.vip_price && storeInfo.vip_price > 0"
              >￥{{ storeInfo.vip_price }}</span
                >-->
                </div>
                <!-- <span>价格不含工本费</span> -->
              </div>
              <div class="price-bom price-list">
                <i>优惠券</i>
                <div
                  class="coupon acea-row row-between-wrapper"
                  @click="couponTap"
                  v-if="couponList.length"
                >
                  <div class="hide coupon-list-con acea-row">
                    <div
                      class="activity"
                      v-for="(item, index) in couponList.slice(0, 3)"
                      :key="index"
                    >
                      满{{ item.use_min_price }}减{{ item.coupon_price }}
                    </div>
                  </div>
                  <span class="coupon-btn">领券</span>
                </div>
                <div v-else>暂无可用优惠券</div>
              </div>
            </div>
            <div class="property_con property_con_city">
              <div
                v-if="storeInfo.city_attr"
                class="acea-row row-between-wrapper city"
              >
                <div class="title">服务区域</div>
                <div class="detail-city">
                  <Cascader
                    ref="city"
                    v-model="changeCityValue"
                    :data="city"
                    @on-change="changeCity"
                    change-on-select
                  ></Cascader>
                </div>
              </div>
            </div>
            <div style="height: 60px"></div>
            <div class="btnn acea-row row-between-wrapper">
              <div class="bnt-bottom">
                <div class="bnt acea-row con_agreement">
                  <div class="joinCart" @click="addRecord(salesInfo.saler)">
                    在线咨询
                  </div>
                  <div
                    class="buy"
                    @click="tapBuy"
                    v-if="attr.productSelect.stock > 0"
                  >
                    立即下单
                  </div>
                  <div class="buy bg-color-hui" v-else>去购买</div>
                  <div
                    class="trolley"
                    @click="joinCart"
                    v-if="storeInfo.type === 'goods'"
                  >
                    <img src="@assets/images/gwc.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CouponPop v-on:changeFun="changeFun" :coupon="coupon"></CouponPop>
        </div>
      </div>
      <div class="sales-info" v-if="Object.keys(salesInfo).length > 0">
        <div class="saler" v-if="salesInfo.saler">
          <img
            class="saler-avatar"
            :src="salesInfo.saler.avatar"
            onerror="this.src ='https://www.chuangf.net/uploads/attach/2021/12/20211209/2bb92d9777b6027a7838b018f3fc0a2f.png'"
            alt=""
          />
          <div class="saler-name">{{ salesInfo.saler.real_name }}</div>
          <div class="saler-phone">联系电话：{{ salesInfo.saler.phone }}</div>
          <div class="concat-type">
            <div class="type-item" @click="addRecord(salesInfo.saler)">
              <img
                class="type-icon"
                src="../../assets/images/online.png"
                alt=""
              />
              <span class="type-label">线上咨询</span>
            </div>
            <el-tooltip
              class="item"
              effect="dark"
              :content="
                salesInfo.saler.enterprise_qr_code
                  ? '点击查看二维码'
                  : '暂无二维码'
              "
              placement="top-start"
            >
              <div
                class="type-item"
                @click="
                  salesInfo.saler.enterprise_qr_code
                    ? showQrcode(salesInfo.saler.enterprise_qr_code)
                    : ''
                "
              >
                <img
                  class="type-icon"
                  src="../../assets/images/tob-wechat.png"
                  alt=""
                />
                <span class="type-label">微信联系</span>
                <div
                  class="qrcode-con"
                  v-if="salesInfo.saler.enterprise_qr_code"
                >
                  <img
                    class="qrcode"
                    :src="salesInfo.saler.enterprise_qr_code"
                    alt=""
                  />
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="other-saler" v-if="salesInfo.saler_recomand.length > 0">
          <div class="sale-title">其他咨询顾问</div>
          <div class="sale-list">
            <div
              class="list-item"
              v-for="item in salesInfo.saler_recomand"
              :key="item.uid"
            >
              <img class="item-avatar" :src="item.avatar" alt="" />
              <div class="item-info">
                <div class="name">{{ item.real_name }}</div>
                <div class="item-concat">
                  <div class="concat-btn" @click="addRecord(item)">
                    线上咨询
                  </div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="
                      item.enterprise_qr_code ? '点击查看二维码' : '暂无二维码'
                    "
                    placement="top-start"
                  >
                    <div
                      class="concat-btn"
                      @click="
                        item.enterprise_qr_code
                          ? showQrcode(item.enterprise_qr_code)
                          : ''
                      "
                    >
                      微信联系
                    </div>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="content-left">
        <div
          class="header acea-row row-center-wrapper list-detail"
          v-bind:class="{ goods_on: goodsOn }"
        >
          <div
            class="item"
            :class="navActive === index ? 'on' : ''"
            v-for="(item, index) in navList"
            :key="index"
            @click="asideTap(index)"
          >
            {{ item }}
          </div>
        </div>
        <div class="product-intro" id="title3" ref="conter">
          <div class="conter" id="conter0" v-html="storeInfo.description"></div>
          <div class="conter" id="conter1" v-html="storeInfo.service"></div>
          <div class="conter" id="conter2" v-html="storeInfo.means"></div>
          <div class="conter" id="conter3">
            <img src="@/assets/images/con-fwlc-bg.jpg" />
          </div>
          <div class="FAQ">常见问题</div>
          <div
            class="conter conter4"
            id="conter4"
            v-html="storeInfo.usual"
          ></div>
        </div>
      </div>
      <div>
        <div
          class="content-goods"
          v-bind:class="{ goods_on: goodsOn, goods_on_bottom: goodsBottom }"
          @scroll.native="onScroll"
        >
          <div class="goods_gw">
            <div class="title acea-row row-center-wrapper">
              <div class="titleTxt">
                <span class="content-right-title">
                  <i></i>预约顾问
                  <i></i>
                </span>
              </div>
            </div>
            <div class="goodsform">
              <Input v-model="message.nickname" placeholder="姓名" />
              <Input v-model="message.contact" placeholder="电话" />
              <Input v-model="message.comment" placeholder="需求描述" />
              <div class="buy" @click="messageSubmit">提交</div>
              <span>提交后创孵顾问会联系您</span>
            </div>
          </div>
          <div
            class="superior"
            v-if="storeInfo.hot_list.length > 0"
            id="title2"
          >
            <div class="title acea-row row-center-wrapper">
              <div class="titleTxt">
                <span class="content-right-title">
                  <i></i>热门推荐
                  <i></i>
                </span>
              </div>
            </div>
            <template>
              <div class="content-right">
                <div>
                  <div class="list acea-row row-middle">
                    <div
                      class="item"
                      v-for="val in storeInfo.hot_list"
                      :key="val.image"
                      @click="goGoods(val)"
                    >
                      <div class="pictrue">
                        <img :src="val.image" />

                        <span
                          class="pictrue_log pictrue_log_class"
                          v-if="val.activity && val.activity.type === '1'"
                          >秒杀</span
                        >
                        <span
                          class="pictrue_log pictrue_log_class"
                          v-if="val.activity && val.activity.type === '2'"
                          >砍价</span
                        >
                        <span
                          class="pictrue_log pictrue_log_class"
                          v-if="val.activity && val.activity.type === '3'"
                          >拼团</span
                        >
                      </div>
                      <div class="goods_content">
                        <div class="name line1">{{ val.store_name }}</div>
                        <div class="info line1">{{ val.store_info }}</div>
                        <div class="money font-color-red">
                          <em>¥</em>
                          {{ val.price }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="superior" v-else-if="goodList.length > 0" id="title2">
            <div class="title acea-row row-center-wrapper">
              <div class="titleTxt">
                <span class="content-right-title">
                  <i></i>热门推荐
                  <i></i>
                </span>
              </div>
            </div>
            <template>
              <div class="content-right">
                <div v-for="(item, index) in goodList" :key="index">
                  <div class="list acea-row row-middle">
                    <div
                      class="item"
                      v-for="val in item.list"
                      :key="val.image"
                      @click="goGoods(val)"
                    >
                      <div class="pictrue">
                        <img :src="val.image" />
                        <span
                          class="pictrue_log pictrue_log_class"
                          v-if="val.activity && val.activity.type === '1'"
                          >秒杀</span
                        >
                        <span
                          class="pictrue_log pictrue_log_class"
                          v-if="val.activity && val.activity.type === '2'"
                          >砍价</span
                        >
                        <span
                          class="pictrue_log pictrue_log_class"
                          v-if="val.activity && val.activity.type === '3'"
                          >拼团</span
                        >
                      </div>
                      <div class="goods_content">
                        <div class="name line1">{{ val.store_name }}</div>
                        <div class="info line1">{{ val.store_info }}</div>
                        <div class="money font-color-red">
                          <em>¥</em>
                          {{ val.price }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div
      class="generate-posters acea-row row-middle"
      :class="posters ? 'on' : ''"
    >
      <div class="share-dialog">
        <div class="header">
          <span>分享至</span>
        </div>
        <div class="content">
          <div class="left">
            <div class="share-list">
              <div class="share-type">
                <img src="@assets/images/weibo.png" alt="微博" />
                <span>微博</span>
              </div>
              <div class="share-type">
                <img src="@assets/images/qq.png" alt="qq" />
                <span>QQ</span>
              </div>
            </div>
            <div class="copy-link">
              <span class="copy-text">复制链接进行分享</span>
              <div class="input-content">
                <input
                  readonly
                  type="text"
                  v-model="product_url"
                  class="input-inner"
                />
                <div
                  class="copy-btn"
                  v-clipboard:copy="product_url"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  复制
                </div>
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="right">
            <div class="share-list">
              <div class="share-type">
                <img src="@assets/images/dingding.png" alt="钉钉" />
                <span>钉钉</span>
              </div>
              <div class="share-type">
                <img src="@assets/images/weixin.png" alt="微信" />
                <span>微信</span>
              </div>
              <span class="share-text">扫描二维码分享</span>
            </div>
            <div class="qrcode">
              <img :src="storeInfo.code_base" alt="qrCode" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      @click="listenerActionClose"
      v-show="posters"
    ></div>
    <el-dialog
      :visible.sync="dialogVisible"
      center
      title="扫一扫 添加您的专属顾问"
      width="30%"
    >
      <div class="qrcode" style="display: flex; justify-content: center">
        <img :src="otherImage" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import "@assets/css/swiper.min.css";
import ProductConSwiper from "@components/ProductConSwiper";
import ProductWindow from "@components/ProductWindow";
import { goShopDetail } from "@libs/order";
import CouponPop from "@components/CouponPop";
import {
  getProductDetail,
  postCartAdd,
  getCartCount,
  getServiceInfo,
  addRecordChatInfo,
} from "@api/store";
import {
  getCoupon,
  getCollectAdd,
  getCollectDel,
  getInvitationCode,
  getAgentInfo,
} from "@api/user";
import { getDefaultCity, getThisCity, getThisAdcode } from "@api/public";
import { isWeixin } from "@utils/index";
import { wechatEvevt } from "@libs/wechat";
// import { imageBase64 } from "@api/public";
// import { mapGetters } from "vuex";
import { trim } from "@utils";
import { messageSubmit } from "@api/public";
import { required, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { mapMutations } from "vuex";
import cookie from "@utils/store/cookie";
const SELECTCITY = "selectcity";
const THISCITY = "thiscity";
const CITYDATA = "citydata";
const ADCODE = "adcode";
let NAME = "GoodsCon";
export default {
  name: NAME,
  metaInfo() {
    return {
      title: this.seo_title,
      meta: this.metaData,
    };
  },
  components: {
    ProductConSwiper,
    ProductWindow,
    CouponPop,
  },

  data: function () {
    return {
      salesInfo: {}, //销售员信息
      dialogVisible: false, // 其他销售员二维码弹窗
      otherImage: "", // 其他销售员二维码信息
      seo_title: "",
      metaData: [],
      single: true,
      modal2: false,
      iSplus: true,
      shareInfoStatus: false,
      weixinStatus: false,
      product_url: window.location.href,
      posterData: {
        image: "",
        title: "",
        price: "",
        code: "",
      },
      attrtext: [],
      changeCityValue: [],
      city: [],
      thiscity: "",
      posterImageStatus: false,
      animated: false,
      coupon: {
        coupon: false,
        list: [],
      },
      attr: {
        cartAttr: false,
        productAttr: [],
        productSelect: {},
      },
      isOpen: false, //是否打开属性组件
      productValue: [],
      id: 0,
      storeInfo: {
        hot_list: [],
      },
      couponList: [],
      attrTxt: "请选择",
      attrValue: "",
      cart_num: 1, //购买数量
      replyCount: "",
      replyChance: "",
      reply: [],
      priceName: 0,
      CartCount: 0,
      posters: false,
      banner: [{}, {}],
      goodList: [],
      system_store: {},
      storeSelfMention: true,
      storeItems: {},
      activity: [],
      navList: [],
      lock: false,
      navActive: 0,
      goodsOn: false,
      goodsBottom: false,
      bussinessType: false,
      share_url: "",
      message: {},
      invitation_code: "",
      conter0: 0,
      conter1: 0,
      conter2: 0,
      conter3: 0,
      conter4: 0,
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    getiscity() {
      return this.iscity;
    },
  },
  inject: ["iscity"],
  watch: {
    $route(n) {
      if (n.name === NAME) {
        this.id = n.params.id;
        this.storeInfo.slider_image = [];

        this.coupons();
        this.$router.go(0);
      }
    },
    getiscity: function () {
      let that = this;
      that.$nextTick(function () {
        let cityData = cookie.get(CITYDATA);
        let adcode = cityData.ad_info.adcode.toString().substr(0, 4) + "00";
        getThisAdcode(adcode).then((res) => {
          that.location = res.data;
          if (
            cookie.get(THISCITY) &&
            cookie.get(SELECTCITY) &&
            cookie.get(ADCODE)
          ) {
            that.thiscity = cookie.get(THISCITY);
            that.selectcity = cookie.get(SELECTCITY);
          } else {
            that.thiscity = that.location.name;
            that.selectcity = that.location.city_id;
            cookie.set(THISCITY, that.thiscity);
            cookie.set(SELECTCITY, that.selectcity);
            cookie.set(ADCODE, adcode);
          }
          this.productCon();
        });
      });
    },
    "$store.state.app.switchcity"(code) {
      this.switchCity = code;
    },
  },
  updated() {
    // window.scroll(0, 0);
  },
  mounted: function () {
    window.$con = this;
    console.log("imUrl", this.imUrl);
    this.id = this.$route.params.id;
    this.storeInfo.slider_image = [];
    let that = this;
    //↓获取当前账号的分享码
    getInvitationCode()
      .then((res) => {
        that.invitation_code = res.data.invitation_code;
      })
      .catch(() => {
        that.nvitation_code = "";
      });
    //↓将链接中带有的有效的邀请码设置入cookie
    getAgentInfo({
      invitation_code: this.$route.params.code,
    })
      .then((res) => {
        this.$store.commit("SET_CODE", res.data.invitation_code);
        // cookie.set("invitationCode", res.data.invitation_code);
      })
      .catch(() => {});
    this.productCon();
    this.coupons();

    this.shareHref();

    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapMutations(["TOLOGINPOP"]),
    addRecord(data) {
      addRecordChatInfo({ product_id: this.id }).then(() => {
        this.onlineConcat(data);
      });
    },
    showQrcode(code) {
      if (code) {
        this.dialogVisible = true;
        this.otherImage = code;
      }
    },
    onlineConcat(data) {
      // http://im.host.113.360-gx.com/chat/index?noCanClose=1&token=6a9bd1bca5a361b011451a1d2df0bdb7&kefu_id=11&uid=2022956002&chuang_token=
      if (!cookie.get("login_status")) {
        this.TOLOGINPOP();
        return;
      }
      let url = `${this.imUrl}/chat/index?noCanClose=1&token=${
        data.token
      }&kefu_id=${data.service_uid}&chuang_token=${
        cookie.get("login_status") || ""
      }`;
      window.open(url);
    },
    // 分销
    shareHref() {
      getInvitationCode()
        .then((res) => {
          let invitation_code = res.data.invitation_code;
          let href = location.href;
          let index = location.href.indexOf("?");
          if (invitation_code) {
            href =
              location.href.indexOf("?") === -1
                ? href + "/" + invitation_code
                : href.slice(0, index) +
                  "/" +
                  invitation_code +
                  href.slice(index);
          }
          this.product_url = href;
        })
        .catch(() => {});
    },
    async messageSubmit() {
      const comment = trim(this.message.comment),
        nickname = this.message.nickname,
        contact = this.message.contact;

      let that = this;
      await this.$validator({
        nickname: [required(required.message("姓名"))],
        contact: [required("请填写手机号码"), chs_phone("请填写正确手机号码")],
        comment: [required(required.message("内容"))],
      })
        .validate({ nickname, contact, comment })
        .then(() => {
          messageSubmit(this.message)
            .then(() => {
              // that.nickname = "";
              // that.message.contact = "";
              that.message = {};
              that.$dialog.success("留言成功");
            })
            .catch((res) => {
              that.$dialog.error(res.msg);
            });
        })
        .catch((e) => {
          return validatorDefaultCatch(e);
        });
    },
    del() {
      setTimeout(() => {
        this.modal2 = false;
      }, 2000);
    },
    changeCity: function (e) {
      this.changeCityValue = e;
      const res = this.findTextAndValue(this.city);
      this.chooseCityArr = res.chooseCityArr;
      let cityR = this.chooseCityArr[this.chooseCityArr.length - 1];
      this.attr.productAttr.map((item) => {
        item.is_location == 1 ? (item.index = cityR) : "";
        return item;
      });
      let value = this.getCheckedValue().sort().join(",");
      this.areaOn = false;
      this.ChangeAttr(value);
    },
    //获取被选中属性；
    getCheckedValue: function () {
      let productAttr = this.attr.productAttr;
      let value = [];
      for (let i = 0; i < productAttr.length; i++) {
        for (let j = 0; j < productAttr[i].attr_value.length; j++) {
          if (productAttr[i].index === productAttr[i].attr_value[j].attr) {
            value.push(productAttr[i].attr_value[j].attr);
          }
        }
      }
      return value;
    },
    findTextAndValue: function (addressData) {
      const res = {
        chooseCityArr: [],
      };
      addressData.some((item) => {
        if (item.value == this.changeCityValue[0]) {
          res.chooseCityArr.push(item.label);
          if (item.children) {
            item.children.some((item) => {
              if (item.value == this.changeCityValue[1]) {
                res.chooseCityArr.push(item.label);
                if (item.children) {
                  item.children.some((item) => {
                    if (item.value == this.changeCityValue[2]) {
                      res.chooseCityArr.push(item.label);
                      return true;
                    }
                  });
                }
                return true;
              }
            });
          }
          return true;
        }
      });
      // addressData.forEach(item => {
      //   res.changeCityValue.push(item.city_id);
      //   res.chooseCityArr.push(item.text);
      // });
      return res;
    },
    onCopy() {
      this.$dialog.toast({ mes: "复制成功！" });
    },
    onError() {
      this.$dialog.toast({ mes: "复制失败！" });
    },
    handleScroll() {
      let top = document.body.scrollTop || document.documentElement.scrollTop;
      if (top - 200 > this.$refs.header.offsetHeight) {
        this.goodsOn = true;
      } else {
        this.goodsOn = false;
        this.goodsBottom = false;
      }
      let scrolled = Math.abs(
        document.getElementById("app").getBoundingClientRect().top
      );
      this.conter0 = document.querySelector("#conter0").offsetTop - 100;
      this.conter1 = document.querySelector("#conter1").offsetTop - 100;
      this.conter2 = document.querySelector("#conter2").offsetTop - 100;
      this.conter3 = document.querySelector("#conter3").offsetTop - 100;
      this.conter4 = document.querySelector("#conter4").offsetTop - 100;
      if (scrolled < this.conter0) {
        this.navActive = 0;
      } else if (scrolled >= this.conter0 && scrolled < this.conter1) {
        this.navActive = 0;
      } else if (scrolled >= this.conter1 && scrolled < this.conter2) {
        this.navActive = 1;
      } else if (scrolled >= this.conter2 && scrolled < this.conter3) {
        this.navActive = 2;
      } else if (scrolled >= this.conter3 && scrolled < this.conter4) {
        this.navActive = 3;
      } else {
        this.navActive = 4;
      }
      if (
        top + 400 >=
        this.$refs.header.offsetHeight + this.$refs.conter.offsetHeight
      ) {
        this.goodsBottom = true;
      } else {
        this.goodsBottom = false;
      }
      if (
        top + 400 >=
        this.$refs.header.offsetHeight + this.$refs.conter.offsetHeight
      ) {
        this.goodsBottom = true;
      } else {
        this.goodsBottom = false;
      }
    },
    asideTap(a) {
      this.$nextTick(() => {
        let index = a;
        // this.navActive = index;
        // if (!this.goodList.length && index === 2) {
        //   index = 3;
        // }
        let element = document.querySelector("#conter" + index);
        const top =
          element.offsetTop +
          this.$refs.header.offsetHeight -
          window.scrollY -
          691;
        // const top = element.offsetTop + this.$refs.header.offsetHeight
        this.lock = true;
        window.scrollBy({ top, left: 0, behavior: "smooth" });
      });
    },
    showChang: function () {
      if (isWeixin()) {
        let config = {
          name: this.storeItems.name,
          address: this.storeItems.address + this.system_store.detailed_address,
        };
        wechatEvevt("openLocation", config)
          .then((res) => {
            console.log(res);
          })
          .catch((res) => {
            if (res.is_ready) {
              res.wx.openLocation(config);
            }
          });
      }
    },
    updateTitle() {
      document.title = this.storeInfo.seo_name || this.$route.meta.title;
    },
    //产品详情接口；
    productCon: function () {
      let that = this;
      getProductDetail(that.id)
        .then((res) => {
          this.metaData = [
            {
              // set meta
              name: "keywords",
              content: res.data.storeInfo.keyword,
            },
            {
              // set meta
              name: "description",
              content: res.data.storeInfo.seo_description,
            },
          ];
          that.$set(that, "storeInfo", res.data.storeInfo);
          this.seo_title = res.data.storeInfo.seo_name
            ? res.data.storeInfo.seo_name
            : res.data.storeInfo.store_name;
          that.$set(that.attr, "productAttr", res.data.productAttr);
          that.$set(that, "productValue", res.data.productValue);
          that.$set(that, "replyCount", res.data.replyCount);
          that.$set(that, "replyChance", res.data.replyChance);
          that.reply = res.data.reply ? [res.data.reply] : [];
          that.$set(that, "reply", that.reply);
          that.$set(that, "priceName", res.data.priceName);
          that.posterData.image = that.storeInfo.image_base;
          that.activity = res.data.activity ? res.data.activity : [];
          if (that.storeInfo.store_name.length > 24) {
            that.posterData.title =
              that.storeInfo.store_name.substring(0, 24) + "...";
          } else {
            that.posterData.title = that.storeInfo.store_name;
          }
          that.storeSelfMention = res.data.store_self_mention ? true : false;
          that.posterData.price = that.storeInfo.price;
          that.posterData.code = that.storeInfo.code_base;
          that.system_store = res.data.system_store;
          let good_list = res.data.good_list || [];
          let goodArray = [];
          let count = Math.ceil(good_list.length / 5);
          for (let i = 0; i < count; i++) {
            var list = good_list.slice(i * 5, i * 5 + 5);
            if (list.length) goodArray.push({ list: list });
          }

          that.$set(that, "goodList", goodArray);
          let navList = [
            "服务详情",
            "服务流程",
            "办理材料",
            "服务保障",
            "常见问题",
          ];
          // if (goodArray.length) {
          //   navList.splice(2, 0, "推荐");
          // }
          that.navList = navList;
          that.updateTitle();
          that.DefaultSelect();
          that.getCartCount();
          that.getCityList();
          this.getSalesInfo();
          // that.getImageBase64();
          // that.setOpenShare();
        })
        .catch((err) => {
          that.$dialog.error(err.msg);
          // that.$router.go(-1);
        });
    },
    // getImageBase64: function () {
    //   let that = this;
    //   imageBase64(this.posterData.image, that.posterData.code)
    //     .then((res) => {
    //       that.posterData.image = res.data.image;
    //       that.posterData.code = res.data.code;
    //       that.isLogin && that.shareCode();
    //     })
    //     .catch(() => {
    //       that.isLogin && that.shareCode();
    //     });
    // },
    //默认选中属性；
    DefaultSelect: function () {
      const that = this;
      let productAttr = this.attr.productAttr,
        value = [];
      // 根据有库存寻找默认的选中
      console.log(productAttr);
      for (var key in this.productValue) {
        if (this.productValue[key].stock > 0) {
          value = this.attr.productAttr.length ? key.split(",") : [];
          break;
        }
      }
      // 根据商品名字
      for (var key in this.productValue) {
        if (key == this.storeInfo.store_name) {
          value = this.attr.productAttr.length
            ? this.storeInfo.store_name.split(",")
            : [];
          break;
        }
      }

      // 根据默认选择选中
      for (var key in this.productValue) {
        if (this.productValue[key].default == 1) {
          value = this.attr.productAttr.length ? key.split(",") : [];
          break;
        }
      }

      for (let i = 0; i < productAttr.length; i++) {
        productAttr = productAttr.map((item) => {
          if (item.attr_values.indexOf(value[i]) > -1) {
            item["index"] = value[i];
          }
          return item;
        });
        // this.$set(productAttr[i], "index", value[i]);
      }
      // 根据定位来选择属性
      var selectcity = cookie.get(SELECTCITY);
      for (var key in this.productValue) {
        if (
          this.productValue[key].hasOwnProperty("city_value") &&
          this.productValue[key].city_value &&
          this.productValue[key].city_value.indexOf(selectcity) > -1
        ) {
          value = this.attr.productAttr.length ? key.split(",") : [];
          break;
        }
      }
      // 把默认选中渲染到页面
      for (let i = 0; i < productAttr.length; i++) {
        productAttr = productAttr.map((item) => {
          if (item.attr_values.indexOf(value[i]) > -1) {
            item["index"] = value[i];
          }
          return item;
        });
      }
      productAttr.forEach((item) => {
        if (typeof item.is_location != "undefined") {
          if (item.is_location == 1) {
            that.attr.changeCityName == item.index;
          }
        }
      });
      //sort();排序函数:数字-英文-汉字；
      console.log(value);
      // 校正key值
      for (let key in this.productValue) {
        var key_value = key.split(",");
        var match = value.every((item) => {
          for (var i = 0; i < key_value.length; i++) {
            var thisEntry = key_value[i].toString();
            if (thisEntry == item) {
              return true;
            }
          }
          return false;
        });
        if (match === true) {
          value = key.split(",");
          break;
        }
      }

      let productSelect = this.productValue[value.join(",")];
      console.log(productSelect);
      if (productSelect && productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.storeInfo.store_name
        );
        // this.$set(this.attr.productSelect, "image", productSelect.image);
        // this.$set(this.attr.productSelect, "price", productSelect.price);
        // this.$set(this.attr.productSelect, "stock", productSelect.stock);
        // this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr, "productSelect", productSelect);
        // this.$set(this.storeInfo, "store_name", productSelect.suk);
        this.$set(this.storeInfo, "price", productSelect.price);
        if (productSelect.attrtext != "")
          this.$set(
            this,
            "attrtext",
            productSelect.attrtext.split(/[(\r\n)\r\n]+/)
          );
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", value.join(","));
        this.$set(this, "attrTxt", "已选择");
      } else if (!productSelect && productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.storeInfo.store_name
        );
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", value.join(","));
        this.$set(this, "attrTxt", "请选择");
      } else if (!productSelect && !productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.storeInfo.store_name
        );
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", this.storeInfo.stock);
        this.$set(
          this.attr.productSelect,
          "unique",
          this.storeInfo.unique || ""
        );
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      }
    },
    getCityList: function () {
      let that = this;
      getDefaultCity(that.id)
        .then((res) => {
          that.city = res.data;
          that.thiscity = cookie.get(SELECTCITY);
          // let citys = that.city.indexOf(city);
          // that.changeCityValue = [city];
          // var citystate = that.city.find(item => item.value === thiscity);
          if (that.thiscity == null) that.thiscity = 0;
          if (that.thiscity != 0) {
            getThisCity(that.thiscity, that.id)
              .then((res) => {
                that.changeCityValue = res.data.reverse();
              })
              .catch((error) => {
                that.$dialog.error(error.msg);
              });
          } else {
            if (that.storeInfo.city_attr) {
              that.changeCityValue = [that.city[0].value];
            }
          }
        })
        .catch((error) => {
          that.$dialog.error(error.msg);
        });
    },
    //购物车；
    ChangeCartNum: function (changeValue) {
      //changeValue:是否 加|减
      //获取当前变动属性
      let productSelect = this.productValue[this.attrValue];
      //如果没有属性,赋值给商品默认库存
      if (productSelect === undefined && !this.attr.productAttr.length)
        productSelect = this.attr.productSelect;
      //无属性值即库存为0；不存在加减；
      if (productSelect === undefined) return;
      let stock = productSelect.stock || 0;
      let num = this.attr.productSelect;
      if (changeValue) {
        num.cart_num++;
        if (num.cart_num > stock) {
          this.$set(this.attr.productSelect, "cart_num", stock ? stock : 1);
          this.$set(this, "cart_num", stock ? stock : 1);
        }
      } else {
        num.cart_num--;
        if (num.cart_num < 1) {
          this.$set(this.attr.productSelect, "cart_num", 1);
          this.$set(this, "cart_num", 1);
        }
      }
    },
    //将父级向子集多次传送的函数合二为一；
    changeFun: function (opt) {
      console.log(opt);
      if (typeof opt !== "object") opt = {};
      let action = opt.action || "";

      let value = opt.value === undefined ? "" : opt.value;
      this[action] && this[action](value);
    },
    //打开优惠券插件；
    couponTap: function () {
      let that = this;
      that.coupons();
      that.coupon.coupon = true;
    },
    changecoupon: function (msg) {
      this.coupon.coupon = msg;
      this.coupons();
    },
    currentcoupon: function (res) {
      let that = this;
      that.coupon.coupon = false;
      that.$set(that.coupon.list[res], "is_use", true);
    },
    //可领取优惠券接口；
    coupons: function () {
      let that = this,
        q = { page: 1, limit: 20, type: 1, product_id: that.id };
      getCoupon(q).then((res) => {
        that.$set(that, "couponList", res.data || []);
        that.$set(that.coupon, "list", res.data);
      });
    },
    //选择属性；
    ChangeAttr: function (res) {
      const that = this;

      var res_arr = res.split(",");
      for (let key in this.productValue) {
        var key_value = key.split(",");
        var match = res_arr.every((item) => {
          for (var i = 0; i < key_value.length; i++) {
            var thisEntry = key_value[i].toString();
            if (thisEntry == item) {
              return true;
            }
          }
          return false;
        });
        if (match) {
          res = key;
        }
      }
      console.log(res);

      let productSelect = this.productValue[res];
      if (productSelect) {
        // this.$set(this.attr.productSelect, "image", productSelect.image);
        // this.$set(this.attr.productSelect, "price", productSelect.price);
        // this.$set(this.attr.productSelect, "stock", productSelect.stock);
        // this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr, "productSelect", productSelect);
        this.$set(this.attr.productSelect, "cart_num", 1);
        // this.$set(this.storeInfo, "store_name", productSelect.suk);
        this.$set(this.storeInfo, "price", productSelect.price);
        if (productSelect.attrtext != "")
          this.$set(
            this,
            "attrtext",
            productSelect.attrtext.split(/[(\r\n)\r\n]+/)
          );
        this.$set(this, "attrValue", res);
        this.$set(this, "attrTxt", "已选择");
      } else {
        // let res = res.split(",");
        for (let key in this.productValue) {
          let ketString = key.split(",").sort().toString();
          let resString = res.split(",").sort().toString();
          if (ketString == resString) {
            that.ChangeAttr(key);
            break;
          }
        }
        productSelect = this.productValue[res];
        // this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        // this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        // this.$set(this.attr.productSelect, "stock", 0);
        // this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", res);
        this.$set(this, "attrTxt", "请选择");
      }
    },
    //收藏商品
    setCollect: function () {
      let that = this,
        id = that.storeInfo.id,
        category = "product";
      if (that.storeInfo.userCollect) {
        getCollectDel(id, category).then(function () {
          that.storeInfo.userCollect = !that.storeInfo.userCollect;
        });
      } else {
        getCollectAdd(id, category).then(function () {
          that.storeInfo.userCollect = !that.storeInfo.userCollect;
        });
      }
    },
    goGoods(item) {
      goShopDetail(item).then(() => {
        window.scroll(0, 0);
        this.$router.push({ path: "/detail/" + item.id + "?" + item.pinyin });
      });
    },
    //  点击加入购物车按钮
    joinCart: function () {
      //0=加入购物车
      this.goCat(0);
    },
    // 加入购物车；
    goCat: function (news) {
      let that = this,
        productSelect = that.productValue[this.attrValue];
      this.isOpen = true;
      //打开属性
      if (this.isOpen) this.attr.cartAttr = true;
      else this.attr.cartAttr = !this.attr.cartAttr;

      //只有关闭属性弹窗时进行加入购物车
      if (this.attr.cartAttr === true && this.isOpen === false)
        return (this.isOpen = true);
      if (
        !this.attr.productSelect.cart_num ||
        parseInt(this.attr.productSelect.cart_num) <= 0
      )
        return this.$dialog.toast({ mes: "请输入购买数量" });
      //如果有属性,没有选择,提示用户选择
      if (
        this.attr.productAttr.length &&
        productSelect === undefined &&
        this.isOpen === true
      )
        return this.$dialog.toast({ mes: "产品库存不足，请选择其它" });
      if (this.storeInfo.city_attr != "" && this.changeCityValue.length == 0) {
        return this.$dialog.toast({ mes: "请选择服务区域" });
      }

      let q = {
        productId: this.id,
        cartNum: this.attr.productSelect.cart_num,
        new: news,
        uniqueId:
          this.attr.productSelect !== undefined
            ? this.attr.productSelect.unique
            : "",
        cityValue: this.changeCityValue,
        is_addr: that.storeInfo.is_address,
      };
      postCartAdd(q)
        .then(function (res) {
          that.isOpen = false;
          that.attr.cartAttr = false;
          if (news) {
            that.$router.push({ path: "/order/submit/" + res.data.cartId });
          } else {
            that.$dialog.toast({
              mes: "添加购物车成功",
              callback: () => {
                that.getCartCount(true);
              },
            });
          }
        })
        .catch((res) => {
          that.isOpen = false;
          return that.$dialog.toast({ mes: res.msg });
        });
    },
    //获取购物车数量
    getCartCount: function (isAnima) {
      let that = this;
      const isLogin = that.isLogin;
      if (isLogin) {
        getCartCount({ numType: 0 }).then((res) => {
          that.CartCount = res.data.count;
          //加入购物车后重置属性
          if (isAnima) {
            that.animated = true;
            setTimeout(function () {
              that.animated = false;
            }, 500);
          }
        });
      }
    },
    //获取销售员信息
    getSalesInfo() {
      getServiceInfo(this.id).then(({ data }) => {
        this.salesInfo = data;
      });
    },
    //立即购买；
    tapBuy: function () {
      //  1=直接购买
      this.goCat(1);
    },
    listenerActionSheet: function () {
      if (isWeixin() === true) {
        this.weixinStatus = true;
      }
      this.posters = true;
    },
    listenerActionClose: function () {
      this.posters = false;
    },
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.handleScroll);
  },
  projectType: function () {
    this.$nextTick(function () {
      let cur = this.$refs["bussinessTypeRef"];
      if (cur) {
        this.bussinessHeight = cur.clientHeight;
      }
    });
  },
};
</script>
<style scoped lang="scss">
.app {
  position: relative;
}
.goods-info {
  display: flex;
  .basic-info {
    // width: 968px;
    position: relative;
  }
  .sales-info {
    width: 285px;
    margin-left: 10px;
    background-color: #fff;
    .saler {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      border-bottom: 11px solid #f5f5f5;
      .saler-avatar {
        width: 90px;
        height: 90px;
        border-radius: 3px;
        margin-top: 27px;
      }
      .saler-name {
        font-size: 16px;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 16px;
        width: 100%;
        text-align: center;
        margin: 10px 0;
      }
      .saler-phone {
        font-size: 14px;
        font-weight: 400;
        text-align: LEFT;
        color: #686868;
        line-height: 14px;
      }
      .concat-type {
        display: flex;
        width: 100%;
        justify-content: space-around;
        .type-item {
          width: 94px;
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 37px;
          border-radius: 3px;
          margin-top: 16px;
          margin-bottom: 26px;
          cursor: pointer;
          position: relative;
          &:first-of-type {
            background: rgba(0, 124, 249, 0.1);
            color: #007cf9;
          }
          &:last-of-type {
            background: rgba(2, 187, 111, 0.1);
            color: #02bb6f;
            //   &:hover {
            //     .qrcode-con {
            //       display: flex;
            //     }
            //   }
          }
          .type-icon {
            width: 24px;
            height: 24px;
          }
          .type-label {
            font-size: 14px;
            font-weight: 500;
            text-align: LEFT;

            line-height: 14px;
          }
          .qrcode-con {
            // display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 30px;
            width: 94px;
            height: 80px;
            background: #e6f9f1;
            border-radius: 0px 0px 3px 3px;
            display: none;
            .qrcode {
              width: 70px;
              height: 70px;
              border-radius: 3px;
            }
          }
        }
      }
    }
    .other-saler {
      padding: 16px 11px;
      box-sizing: border-box;
      .sale-title {
        font-size: 16px;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 16px;
        margin-bottom: 16px;
      }
      .sale-list {
        .list-item {
          display: flex;
          margin-bottom: 16px;
          cursor: pointer;
          // align-items: center;
          // align-item;
          .item-avatar {
            width: 60px;
            height: 60px;
            border-radius: 3px;
          }
          .item-info {
            margin-left: 10px;
            .item-concat {
              display: flex;
              align-content: space-between;
              align-items: center;
              height: 55px;
              .concat-btn {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 60px;
                height: 24px;
                border-radius: 3px;
                font-size: 10px;
                font-weight: 500;
                text-align: LEFT;
                color: #02bb6f;
                line-height: 10px;
                &:first-of-type {
                  background: rgba(0, 124, 249, 0.1);
                  color: #007cf9;
                }
                &:last-of-type {
                  background: rgba(2, 187, 111, 0.1);
                  color: #02bb6f;
                  margin-left: 10px;
                  position: relative;
                  // &:hover {
                  //   .other-saler-qrcode {
                  //     display: flex;
                  //   }
                  // }
                  .other-saler-qrcode {
                    position: absolute;
                    top: 22px;
                    display: none;
                    width: 60px;
                    height: 45px;
                    background: #e6f9f1;
                    border-radius: 0px 0px 3px 3px;
                    justify-content: center;
                    align-items: center;
                    .qrcode-image {
                      width: 39px;
                      height: 40px;
                      border-radius: 3px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

#title0 {
  background-color: #fff;
  box-shadow: 0 2px 10px 0 rgba(193, 199, 212, 0.4);
  padding: 16px;
}
.goods-top-direct {
  display: flex;
  justify-content: space-between;
}
.goods-top {
  width: 100%;
}
.mask {
  z-index: 888 !important;
}
.activity_pin {
  width: auto;
  height: 0.44rem;
  background: linear-gradient(
    90deg,
    rgba(233, 51, 35, 1) 0%,
    rgba(250, 101, 20, 1) 100%
  );
  opacity: 1;
  border-radius: 0.22rem;
  padding: 0 0.2rem;
  margin-left: 0.19rem;
}
.activity_miao {
  width: auto;
  height: 0.44rem;
  padding: 0 0.2rem;
  background: linear-gradient(
    90deg,
    rgba(250, 102, 24, 1) 0%,
    rgba(254, 161, 15, 1) 100%
  );
  opacity: 1;
  border-radius: 0.22rem;
  margin-left: 0.19rem;
}
s {
  color: #fff !important;

  display: block;
}
.activity_title {
  font-size: 0.24rem;
  color: #fff;
}
.activity_kan {
  width: auto;
  height: 0.44rem;
  padding: 0 0.2rem;
  background: linear-gradient(
    90deg,
    rgba(254, 159, 15, 1) 0%,
    rgba(254, 178, 15, 1) 100%
  );
  opacity: 1;
  border-radius: 0.22rem;
  margin-left: 0.19rem;
}
.addressBox .phone {
  margin-left: 1.1rem;
}
.corlor-red {
  color: #fc4141;
}
.store-box {
  padding: 0 0.3rem;
  border-bottom: 1px solid #f5f5f5;
}
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}
.product-con {
  width: 1200px;
  margin: 20px auto;
  position: relative;
}
.list-detail {
  width: 100%;
  height: 50px;
  z-index: 99;
  margin-top: 20px;
  display: flex;
  background: #fff;
  justify-content: left;
}
.list-detail .item {
  text-align: center;
  width: 128px;
  line-height: 44px;
  display: inline-block;
  cursor: pointer;
  position: relative;
  top: 0px;
  color: #333333;
  font-size: 16px;
}
.list-detail .item.on {
  background: #fff;
  height: 47px;
  color: #ff6a00;
  font-weight: 600;
  border-top: 2px solid #ff6a00;
  position: relative;
  top: 0px;
}

.goodsform .ivu-input-wrapper {
  padding: 6px 20px;
}
.goodsform .buy {
  width: 150px;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
  border-radius: 3px;
  background: #ff6a00;
  color: #fff;
  height: 32px;
  margin: 15px auto 0;
}
.goodsform span {
  margin-top: 10px;
  display: block;
  font-size: 14px;
  color: #969696;
  text-align: center;
}
.product-con .store-info {
  margin-top: 0.2rem;
  background-color: #fff;
}
.product-con .store-info .title {
  color: #282828;
  height: 0.8rem;
  line-height: 0.8rem;
  border-bottom: 0.01rem solid #f5f5f5;
}
.product-con .store-info .info {
  padding: 0 0.3rem;
  height: 1.26rem;
}
.store-info .icon-jiantou {
  color: #7a7a7a;
}
.product-con .store-info .info .pictrue {
  width: 0.76rem;
  height: 0.76rem;
}
.product-con .store-info .info .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.06rem;
}
.product-con .store-info .info .text {
  width: 56%;
}
.product-con .store-info .info .text .name {
  color: #282828;
}
.product-con .store-info .info .text .address {
  font-size: 0.24rem;
  color: #666;
  margin-top: 0.03rem;
}
.product-con .store-info .info .text .address .iconfont {
  color: #707070;
  font-size: 0.18rem;
  margin-left: 0.1rem;
}
.address_tit {
  max-width: 88% !important;
}
.addressTxt {
  width: auto;
  font-size: 0.24rem;
}
.product-con .store-info .info .iconfont {
  font-size: 0.4rem;
}

.product-con .goods_gw {
  background: #fff;
  padding-bottom: 10px;
}
.product-con .superior .title,
.product-con .goods_gw .title {
  height: 60px;
  background-color: #fff;
}
.product-con .superior .title img {
  width: 20px;
}

.product-con .content-goods {
  margin-top: 20px;
  width: 280px;
}
.product-con .goods_on {
  position: fixed;
  margin-top: 0;
  top: 0;
  bottom: 0;
}
.product-con .goods_on_bottom {
  top: inherit;
  bottom: 380px;
}
.product-con .superior .title .titleTxt,
.product-con .goods_gw .titleTxt {
  margin: 0 20px;
  font-size: 20px;
  font-weight: bold;
  width: 100%;
}
.product-con .titleTxt .ivu-divider-inner-text {
  width: 180px;
  padding: 0 18px !important;
}
.product-con .titleTxt .ivu-divider-horizontal.ivu-divider-with-text-center {
  font-size: 20px !important;
  font-weight: bold !important;
}
.slider-banner {
  width: 530px;
  margin-right: 16px;
  margin-bottom: 16px;
}

.product-con .wrapper {
  width: 328px;
  position: relative;
}

.product-con .superior .slider-banner {
  width: 968px;
  margin: 0 auto;
  padding-bottom: 10px;
}

.product-con .superior .slider-banner .list {
  width: 100%;
  padding-bottom: 0.2rem;
}

.product-con .superior .slider-banner .list .item {
  width: 200px;
  margin: 0 0.21rem 0.2rem 0;
}

.product-con .superior .slider-banner .list .item:nth-of-type(3n) {
  margin-right: 0;
}

.product-con .superior .slider-banner .list .item .pictrue {
  width: 100%;

  position: relative;
}
.product-con .superior .slider-banner .list .item .pictrue img {
  width: 100%;
}
.product-con .superior .slider-banner .list .item .name {
  color: #282828;
  margin-top: 0.12rem;
}
.product-con .superior .slider-banner .swiper-pagination-bullet {
  background-color: #999;
}
.product-con .superior .slider-banner .swiper-pagination-bullet-active {
  background-color: #e93323;
}

.mask {
  -webkit-filter: blur(2px);
  -moz-filter: blur(2px);
  -ms-filter: blur(2px);
  filter: blur(2px);
  z-index: 888 !important;
}
.footer .icon-shoucang1 {
  color: #e93323;
}
.product-con .product-intro .conter div {
  width: 100% !important;
}
.generate-posters {
  background-color: #fff;
  position: fixed;
  left: 50%;
  width: 654px;
  height: 270px;
  padding: 20px 25px;
  margin-left: -225px;
  border-radius: 5px;
  z-index: 999;
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  opacity: 0;
}
.generate-posters.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
  opacity: 1;
  bottom: 50%;
  margin-bottom: -200px;
}
.generate-posters .item {
  flex: 50%;
  -webkit-flex: 50%;
  -ms-flex: 50%;
  text-align: center;
}
.generate-posters .item .iconfont {
  color: #5eae72;
}
.generate-posters .item .iconfont.icon-haibao {
  color: #5391f1;
}
.noscroll {
  height: 100%;
  overflow: hidden;
}
.bnt-bottom {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: inherit;
}
.bnt-share {
  display: flex;
  position: absolute;
  right: 16px;
  top: -7px;
  z-index: 9;
}
.product-con .goods-top .bnt-share {
  top: 10px;
}
.bnt-share .item {
  margin-left: 18px;
  font-size: 12px;
}
.icon-kefu,
.icon-shoucang,
.icon-fenxiang,
.icon-shoucang1 {
  font-size: 22px;
}
.icon-shoucang1 {
  color: #ff6052;
}
.product-con .bnt .ivu-checkbox-wrapper {
  color: #7a8599;
  display: flex;
  align-items: center;
}
.product-con .bnt .ivu-checkbox-wrapper em {
  margin-left: 10px;
}

.content {
  display: flex;
  /* position: relative; */
}
.content-left {
  margin-right: 10px;
  width: 968px;
}
.content-right {
  background-color: #fff;
}
.content-right .list .item {
  width: 280px;
  padding: 0 20px 20px;
  display: flex;
}
.content-right .list .goods_content {
  margin-left: 20px;
  width: 140px;
}
.content-right .list .pictrue {
  width: 80px;
}
.content-right .list a {
  color: #333333;
}
.content-right .list .pictrue img {
  width: 100%;
}
.content-right .list .name {
  padding: 0;
  font-size: 16px;
  font-weight: bold;
}
.content-right .list .info {
  padding: 0;
  margin-bottom: 6px;
  font-size: 14px;
  color: #969696;
}
.content-right .list .money {
  font-size: 24px;
  font-weight: bold;
}
.content-right .list .money em {
  font-size: 18px;
  font-weight: bold;
}
.share-dialog .header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 18px;
  font-weight: bold;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  color: #444;
  margin-bottom: 10px;
}
.share-dialog .content {
  padding: 15px 0;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.share-dialog .content .left {
  width: 290px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column;
  flex-flow: column;
  padding-right: 25px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.share-dialog .content .divider {
  width: 1px;
  background-color: #c3c5c6;
  opacity: 0.4;
}

.share-dialog .content .left .share-list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.share-dialog .content .left .share-list .share-type {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column;
  flex-flow: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.share-dialog .content .left .share-list .share-type:first-child {
  margin-right: 63px;
}
.share-dialog .content .share-list .share-type img {
  height: 48px;
  width: 48px;
  cursor: pointer;
}
.share-dialog .content .left .share-list .share-type span {
  margin-top: 5px;
  font-size: 14px;
}
.share-dialog .content .left .copy-link {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column;
  flex-flow: column;
}
.share-dialog .content .left .copy-link .copy-text {
  line-height: 24px;
  height: 24px;
  font-size: 14px;
}
.share-dialog .content .left .copy-link .input-content {
  height: 36px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 5px;
}
.share-dialog .content .left .copy-link .input-content .input-inner {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  border: 1px solid #d8d8d8;
  border-right: none;
  padding: 0 10px;
}
.share-dialog .content .left .copy-link .input-content .copy-btn {
  width: 80px;
  background-color: #ff6a00;
  color: #fff;
  font-size: 16px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
}
.share-dialog .content .divider {
  width: 1px;
  background-color: #c3c5c6;
  opacity: 0.4;
}
.share-dialog .content .right {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-left: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 313px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.share-dialog .content .right .share-list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column;
  flex-flow: column;
}
.share-dialog .content .right .share-list .share-type {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.share-dialog .content .right .share-list .share-type span {
  margin-left: 8px;
  font-size: 14px;
}
.share-dialog .content .right .share-list .share-text {
  font-size: 14px;
}
.share-dialog .content .right .qrcode {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.share-dialog .content .right .qrcode img {
  height: 154px;
}
.conter4 {
  padding: 0px 32px;
}
.conter4 h3 {
  padding: 20px 0;
}
.FAQ {
  padding: 0 33px;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 2px;
  color: #565353;
  padding-bottom: 15px;
  position: relative;
  margin-bottom: 20px;
}
.FAQ::after {
  width: 50px;
  height: 5px;
  background: #dbdbdb;
  content: "";
  position: absolute;
  bottom: 0;
  left: 30px;
}
.product-window .productWinList .item .hidde {
  height: 65px;
  overflow: hidden;
}
.product-window .productWinList .item .show {
  height: auto;
}
.property_con_city {
  margin-bottom: 0;
}
</style>
